export function getSessionStorageKey(key) {
  if (!window || !window.sessionStorage) return null;
  return window.sessionStorage.getItem(key);
}

export function setSessionStorageKey(key, value) {
  if (!window || !window.sessionStorage) return;
  window.sessionStorage.setItem(key, value);
}
